const nextPage = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      'Content-Type': 'text/html'
    })
    const data = await response.text()
    return data
  } catch (err) {
    console.log(err)
  }
}

const mainBlogGrid = document.querySelector('.blog__main')
const nextPageBtn = document.querySelector('.loader-btn')

if (nextPageBtn && mainBlogGrid) {
  let nextPageUrl = nextPageBtn.href
  nextPageBtn.addEventListener('click', async (e) => {
    e.preventDefault()
    if (nextPageUrl) {
      const domParser = new DOMParser()
      const page = await nextPage(nextPageUrl)
      const pageHTML = domParser.parseFromString(page, 'text/html')
      const posts = pageHTML.documentElement.querySelectorAll('.blog__main__post')
      const nextNextPage = pageHTML.documentElement.querySelector('.loader-btn')
      nextPageUrl = nextNextPage ? nextNextPage.href : null

      if (!nextPageUrl) {
        nextPageBtn.style.display = 'none'
      }

      posts.forEach((post) => {
        if (!post.innerHTML.includes('newsletter')) {
          mainBlogGrid.appendChild(post)
        }
      })
      stripLSepArticleTitle()
    }
  })
}

const blogSliderEl = document.querySelector('.blog__slider')
const blogSlider =
  typeof Swiper !== 'undefined' && blogSliderEl
    ? new Swiper('.blog__slider', {
        loop: true,
        effect: 'coverflow',
        centeredSlides: true,
        slidesPerView: 2.2,
        coverflowEffect: {
          rotate: 0,
          stretch: -25,
          depth: 75,
          modifier: 1,
          slideShadows: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          450: {
            coverflowEffect: {
              rotate: 0,
              stretch: -30,
              depth: 75,
              modifier: 1,
              slideShadows: false
            }
          },
          800: {
            slidesPerView: 2.7,
            coverflowEffect: {
              rotate: 0,
              stretch: -60,
              depth: 75,
              modifier: 1,
              slideShadows: false
            }
          },
          1536: {
            slidesPerView: 2.9,
            coverflowEffect: {
              rotate: 0,
              stretch: -50,
              depth: 75,
              modifier: 1,
              slideShadows: false
            }
          }
        }
      })
    : null

const editorsPicksEl = document.querySelector('.blog__editors-picks__slider')
const editorsPicksSlider =
  typeof Swiper !== 'undefined' && editorsPicksEl
    ? new Swiper('.blog__editors-picks__slider', {
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    : null

const titleCard = document.getElementById('title-card')

if (titleCard) {
  const activeTag = document.querySelector('.swiper-slide-active > .slide-content > p')
  const activeTitle = document.querySelector('.swiper-slide-active > .slide-content > h2')
  if (activeTag && activeTitle && activeTitle.children[0]) {
    activeTitle.children[0].innerText = titleShrink(activeTitle.children[0].innerText)
    const slideContent = document.querySelectorAll('.slide-content')
    slideContent.forEach((slide) => {
      slide.style.display = 'none'
    })
    titleCard.innerHTML = `${activeTag.outerHTML}${activeTitle.outerHTML}`
  }
}

if (blogSlider) {
  blogSlider.on('slideChangeTransitionEnd', () => {
    const activeTag = document.querySelector('.swiper-slide-active > .slide-content > p')
    const activeTitle = document.querySelector('.swiper-slide-active > .slide-content > h2')
    if (activeTag && activeTitle && activeTitle.children[0]) {
      activeTitle.children[0].innerText = titleShrink(activeTitle.children[0].innerText)
      const titleCardEl = document.getElementById('title-card')
      const slideContent = document.querySelectorAll('.slide-content')
      slideContent.forEach((slide) => {
        slide.style.display = 'none'
      })
      titleCardEl.innerHTML = `${activeTag.outerHTML}${activeTitle.outerHTML}`
      stripLSepTopTitle()
    }
  })
}

function stripLSepTopTitle() {
  const topTitle = document.querySelectorAll('.top-title')
  if (!topTitle) {
    return
  }
  topTitle.forEach((title) => {
    if (title.children[0]) {
      title.children[0].innerText = titleShrink(title.children[0].innerText)
      title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
    } else {
      title.innerText = titleShrink(title.innerText)
      title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
    }
  })
}

function stripLSepArticleTitle() {
  const articleTitle = document.querySelectorAll('.article-title')
  if (!articleTitle) {
    return
  }

  articleTitle.forEach((title) => {
    if (title.children[0]) {
      title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
    } else {
      title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
    }
  })
}

function stripLSepEditorsTitle() {
  const editorsTitle = document.querySelectorAll('.editors-title')
  if (!editorsTitle) {
    return
  }
  editorsTitle.forEach((title) => {
    title.innerText = titleShrink(title.innerText)
    title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
  })
}

function titleShrink(title) {
  if (title) {
    title = title.replace(/(\r\n|\n|\r)/gm, '')
    title = title.replace(/  +/g, '')
    if (title[0] == ' ') {
      title = titleShrink(title.substr(1))
    }
    if (title.length > 60) {
      const newTitle = title.substr(0, 60) + '...'
      return newTitle
    } else {
      return title
    }
  } else {
    return title
  }
}

stripLSepTopTitle()
stripLSepArticleTitle()
stripLSepEditorsTitle()
